/* ============================================================
   Vurozen — Theme JavaScript
   Animaciones, interacciones, efectos de scroll
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     1. SCROLL ANIMATIONS — IntersectionObserver
     ---------------------------------------------------------- */
  function initScrollAnimations() {
    const elements = document.querySelectorAll('.hw40-animate');
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ----------------------------------------------------------
     2. COUNTER ANIMATION — números que cuentan al llegar
     ---------------------------------------------------------- */
  function animateCounter(el) {
    const target = parseInt(el.getAttribute('data-target'), 10);
    const duration = 1800;
    const start = performance.now();

    function update(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(eased * target).toLocaleString();
      if (progress < 1) requestAnimationFrame(update);
    }

    requestAnimationFrame(update);
  }

  function initCounters() {
    const counters = document.querySelectorAll('[data-target]');
    if (!counters.length) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    counters.forEach(function (counter) {
      observer.observe(counter);
    });
  }

  /* ----------------------------------------------------------
     3. PARALLAX — secciones hero con fondo fijo
     ---------------------------------------------------------- */
  function initParallax() {
    const parallaxEls = document.querySelectorAll('[data-parallax]');
    if (!parallaxEls.length) return;

    let ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          const scrollY = window.scrollY;
          parallaxEls.forEach(function (el) {
            const speed = parseFloat(el.getAttribute('data-parallax')) || 0.4;
            const rect = el.getBoundingClientRect();
            const offsetTop = rect.top + scrollY;
            const relativeScroll = scrollY - offsetTop;
            el.style.backgroundPositionY = (relativeScroll * speed) + 'px';
          });
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ----------------------------------------------------------
     4. STICKY HEADER — ocultar/mostrar al scroll
     ---------------------------------------------------------- */
  function initStickyHeader() {
    const header = document.querySelector('.header-wrapper, header');
    if (!header) return;

    let lastScroll = 0;
    const threshold = 80;

    window.addEventListener('scroll', function () {
      const currentScroll = window.scrollY;

      if (currentScroll > threshold) {
        header.classList.add('hw40-header--scrolled');
        if (currentScroll > lastScroll) {
          header.classList.add('hw40-header--hidden');
        } else {
          header.classList.remove('hw40-header--hidden');
        }
      } else {
        header.classList.remove('hw40-header--scrolled', 'hw40-header--hidden');
      }

      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* ----------------------------------------------------------
     5. ACCORDION — sección FAQ / beneficios expandible
     ---------------------------------------------------------- */
  function initAccordion() {
    const triggers = document.querySelectorAll('[data-accordion-trigger]');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        const targetId = trigger.getAttribute('data-accordion-trigger');
        const panel = document.querySelector('[data-accordion-panel="' + targetId + '"]');
        if (!panel) return;

        const isOpen = panel.classList.contains('is-open');

        // Cerrar todos
        document.querySelectorAll('[data-accordion-panel]').forEach(function (p) {
          p.classList.remove('is-open');
          p.style.maxHeight = null;
        });
        document.querySelectorAll('[data-accordion-trigger]').forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
        });

        // Abrir el clickeado si estaba cerrado
        if (!isOpen) {
          panel.classList.add('is-open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ----------------------------------------------------------
     6. TRUST BADGES — inyección dinámica en product page
     ---------------------------------------------------------- */
  function injectTrustBadges() {
    const productForm = document.querySelector('.product-form, .product__info-container');
    if (!productForm) return;
    if (document.querySelector('.hw40-trust-bar')) return;

    const badges = [
      { icon: '✓', label: 'Third-Party Tested' },
      { icon: '✓', label: 'Non-GMO' },
      { icon: '✓', label: 'GMP Certified' },
      { icon: '✓', label: 'Free Shipping $50+' },
      { icon: '✓', label: '30-Day Guarantee' }
    ];

    const bar = document.createElement('div');
    bar.className = 'hw40-trust-bar';

    badges.forEach(function (b) {
      const item = document.createElement('div');
      item.className = 'hw40-trust-item';
      item.innerHTML = '<span class="hw40-trust-icon">' + b.icon + '</span><span>' + b.label + '</span>';
      bar.appendChild(item);
    });

    productForm.parentNode.insertBefore(bar, productForm.nextSibling);
  }

  /* ----------------------------------------------------------
     7. INIT — esperar DOM listo
     ---------------------------------------------------------- */
  function init() {
    initScrollAnimations();
    initCounters();
    initParallax();
    initStickyHeader();
    initAccordion();
    injectTrustBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
